import { useState } from "react";
import { ReactComponent as ErrorIcon } from "src/assets/icons/error.svg";

import Button from "../button";
import Typography from "../typography";

interface Props {
	title: string;
	description: string;
	buttonText?: string;
	onClickButton?: () => void;
}
interface ZodIssue {
	code: string;
	expected: string;
	received: string;
	path: (number | string)[];
	message: string;
}

interface ZodError {
	issues: ZodIssue[];
	name: string;
}
export default function ErrorComponent({ description, buttonText, onClickButton }: Props) {
	const [showDetail, setShowDetail] = useState(false);

	let zodError: ZodError | null = null;
	const isZodError = description.includes("ZodError");
	if (isZodError) {
		const message = description.substring(description.indexOf("{"));
		try {
			zodError = JSON.parse(message);
		} catch (error) {
			console.error("Failed to parse JSON:", error);
		}
	}

	return (
		<div className="flex flex-1 flex-col items-center justify-center space-y-4">
			<ErrorIcon />

			<Typography className="mx-auto w-2/3 text-center text-neutral-600" variant="bodyXM">
				Something went wrong! Please try again later.
			</Typography>

			<Button className="bg-secondary text-black" onClick={() => setShowDetail(!showDetail)}>
				{showDetail ? "Hide Detail" : "Show Detail"}
			</Button>

			{showDetail && (
				<div className="flex items-center justify-center rounded-2xl p-3 text-gray-700">
					<Typography>
						{isZodError
							? zodError?.issues.map((issue: any) => (
									<div
										className="mb-2 rounded border-l-4 border-red-500 bg-red-50 p-2"
										key={issue.path.join(" > ")}
									>
										<p>
											<span className="font-semibold">🔹 Path:</span>{" "}
											<code className="rounded bg-gray-200 p-1">{issue.path.join(" > ")}</code>
										</p>
										<p>
											<span className="font-semibold">📌 Message:</span>{" "}
											<span className="text-red-700">{issue.message}</span>
										</p>
										<p>
											<span className="font-semibold">🛠 Expected:</span>{" "}
											<span className="text-blue-600">{issue.expected}</span> |
											<span className="font-semibold"> Received:</span>{" "}
											<span className="text-green-600">{issue.received}</span>
										</p>
									</div>
								))
							: description}
					</Typography>
				</div>
			)}

			<div className="mt-4 flex justify-evenly space-x-4">
				{onClickButton && (
					<Button className="bg-secondary text-black" onClick={onClickButton}>
						{buttonText ?? "Try again"}
					</Button>
				)}
				{/* <Button onClick={() => setShowErrorComponent(false)} className="bg-secondary text-black">
            Go Offline
          </Button> */}
			</div>
		</div>
	);
}
